import { render, staticRenderFns } from "./PriceListItemDialog.vue?vue&type=template&id=2effc347&scoped=true"
import script from "./PriceListItemDialog.vue?vue&type=script&lang=js"
export * from "./PriceListItemDialog.vue?vue&type=script&lang=js"
import style0 from "./PriceListItemDialog.vue?vue&type=style&index=0&id=2effc347&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2effc347",
  null
  
)

export default component.exports